module.exports = __webpack_public_path__ + "static/img/4-4.7b5c26b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/4-4.png
// module id = HcoS
// module chunks = 1